// Diplays an empty cell.
// @flow
import React from 'react';
import { ALIGNMENT_CSS_CLASS } from './constants';

type Alignment = 'center' | 'left' | 'right';

type Props = {
    alignment: Alignment
};

export default (props: Props) => {
    const { alignment } = props;
    return (
        <div
            className={`cell empty ${alignment || ALIGNMENT_CSS_CLASS.CENTER}`}
        >
            -
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/EmptyCell.jsx